import { logException } from '../services/sentryService';

let CSRF = {};

function prependCSRFToken($form) {
  if (
    !window.isCustomerLoggedIn &&
    !window.location.href.includes('/checkout/finish')
  ) {
    return;
  }
  $form
    .filter(':not(:has(input[name="X-CSRF-Token"]))') // only if the CSRF input is not already there
    .prepend(function () {
      let token = window.csrfToken;

      if (typeof token !== 'undefined' && token !== '') {
        return (
          '<input type="hidden" name="X-CSRF-Token" value="' + token + '"/>'
        );
      } else {
        logException(
          `CSRF Token cannot be retrieved for the token: ${token}`,
          { area: 'security' },
          { action: 'CSRF Token Prepend' }
        );
        return '';
      }
    });
}

CSRF.init = function () {
  if (
    !window.isCustomerLoggedIn &&
    !window.location.pathname.includes('/checkout/finish')
  ) {
    return;
  }

  prependCSRFToken($('form[method="POST"]'));

  // Apply CSRF protection token to every POSTed AJAX request
  $(document).ajaxSend(function (event, xhr, options) {
    if (options.type === 'POST') {
      let csrfToken = window.csrfToken;

      if (typeof csrfToken !== 'undefined' && csrfToken !== '') {
        xhr.setRequestHeader('X-CSRF-Token', csrfToken);
      } else {
        logException(
          `CSRF Token cannot be retrieved for the token: ${csrfToken}`,
          { area: 'security' },
          { action: 'CSRF Token Request Header' }
        );
      }
    }
  });
};

CSRF.addCSRFToForm = function ($form) {
  prependCSRFToken($form);
};

export default CSRF;
